!(function(root, app) {
    app.events = app.events || {};
    app.events.anniversary = {
        init: function() {
            this.setupSlider();
            this.setupGameModeCards();
        },
        setupSlider: function () {

            var sticky = new Waypoint.Sticky({
                element: $('#unlock-tabs'),
                stuckClass: 'event-unlock-tabs-fixed'
            });

            var breakpoints = {
                all: {
                    slidesPerView: 6,
                    slideToClickedSlide: false,
                    allowSlideNext: false,
                    allowSlidePrev: false,
                    centeredSlides: false,
                    grabCursor: false,
                    freeMode: false,
                    freeModeSticky: true
                },
                desktop: {
                    slidesPerView: 3,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    centeredSlides: true,
                    grabCursor: true,
                    freeMode: true,
                    freeModeSticky: true
                },
                mobile: {
                    slidesPerView: 1,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    centeredSlides: true,
                    grabCursor: true,
                    freeMode: true,
                    freeModeSticky: true
                }
            };

            var options = {
                init: false,
                a11y: false,
                speed: 600,
                setWrapperSize: true,
                direction: 'horizontal',
                preventInteractionOnTransition: true,
                roundLengths: true,
                runCallbacksOnInit: true,
                iOSEdgeSwipeDetection: true,
                touchEventsTarget: 'wrapper',
                observer: true,
                loop: true,
                loopAdditionalSlides: 1,
                loopFillGroupWithBlank: true,
                //
                breakpoints: {
                    1600: breakpoints.all,
                    1280: breakpoints.desktop,
                    768: breakpoints.mobile
                },
                wrapperClass: 'swiper-wrapper',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            };

            options = _.merge(options, breakpoints.all);

            var slider = new Swiper('.swiper-container', options);

            var previousEventId;
            var activeIndex;

            var onInit = function (e) {
                app.events.base.preselectUnlocks();
                activeIndex = slider.activeIndex;
            };

            var onClick = function onClick(e) {
                var $clickedSlide = $(slider.clickedSlide);
                if ($clickedSlide.length) {
                    var eventId = $clickedSlide.data('id');
                    if (eventId && previousEventId !== eventId) {

                        slider.slideTo(slider.clickedIndex);

                        var $parent = $clickedSlide.parent();
                        $parent.find('.swiper-slide-active').each(function () {
                            $(this).removeClass('swiper-slide-active');
                        })

                        app.events.base.updateUnlocksTab(eventId);
                        $clickedSlide.addClass('swiper-slide-active');

                        previousEventId = eventId;
                        activeIndex = slider.activeIndex;
                    }
                }
            };

            var onChange = function onChange(e) {
                var $item = $('.event-list--anniversary .swiper-slide-active');
                var eventId = $item.find('> [data-js="fetchUnlocks"]').data('id');
                window.localStorage.setItem("selectedEvent", eventId);
                app.events.base.updateUnlocksTab(eventId);
                previousEventId = eventId;
            };

            var onResize = function (e) {
                slider.slideReset();
            };

            $(window).on('resize', _.debounce(onResize, 150));

            slider.on('init', onInit);
            slider.on('click', onClick);
            slider.on('slideChangeTransitionEnd', onChange);
            $(document.body).on("slideout:open slideout:close", function(event, data) {
                if(data.id === "eventDetails") {
                    Waypoint.refreshAll();
                }
            });
            slider.init();
        },
        setupGameModeCards: function () {
            $('[data-js="game-mode-card"]').hide();
            $('[data-js="game-mode-select"]').on("click", function (event) {
                var id = $(this).data('gameModeId');
                $('[data-js="game-modes-index"]').hide();
                $('[data-js="game-mode-card"]').hide();
                $('[data-js="game-mode-card"][data-id=' + id + ']').show().get(0).scrollIntoView({ behavior: 'smooth' });
            });
            $('[data-js="game-modes-back"]').on("click", function (event) {
                $('[data-js="game-mode-card"]').hide();
                $('[data-js="game-modes-index"]').show().get(0).scrollIntoView({ behavior: 'smooth' });
            });
        }
     };
})(this, this.app);
